import { initialState } from '@/Helpers.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

function userCanViewImpersonationLog({ gateKeeper }) {
    const userImpersonationFeature = initialState('Features.USER_IMPERSONATION');

    return (
        gateKeeper.user?.hasActiveFeature?.(userImpersonationFeature) &&
        gateKeeper.userHasPermission('view the impersonation log')
    );
}

export default [
    {
        path: '/impersonation-log',
        component: () => import('@/pages/impersonation-log/ImpersonationLogIndex.vue'),
        props: true,
        children: [
            {
                name: 'impersonation-log-index',
                path: '',
                component: () => import('@/components/impersonation-log/ImpersonationLog.vue'),
                meta: {
                    title: 'Impersonation Log',
                    middleware: [GateKeeperMiddleware],
                    ability: userCanViewImpersonationLog,
                    dataTablePage: true,
                },
                props: true,
            },
        ],
    },
];
